export const doestItHaveChildren = (category: any) => {
  return category && category.hasOwnProperty('children') && category.children.length > 0;
}